import buttonClasses from "@mui/material/Button/buttonClasses";
import { fontFamily, typography, typographyResponsive } from "../../styles/utils/typography.module";
export const typographyTheme = (dt) => {
    const buttonTypography = typographyResponsive(dt, "button.medium");
    buttonTypography[`&.${buttonClasses.sizeSmall}`] = typographyResponsive(dt, "button.small");
    buttonTypography[`&.${buttonClasses.sizeLarge}`] = typographyResponsive(dt, "button.large");
    const returnVar = {
        fontFamily: fontFamily(dt.fontFamilies.body.default, dt.fontFamilies.body.fallback),
        htmlFontSize: Number.parseInt(dt.unit.type.toString()),
        fontWeightLight: dt.typography.default.body1.light.fontWeight,
        fontWeightRegular: dt.typography.default.body1.regular.fontWeight,
        fontWeightMedium: dt.typography.default.body1.medium.fontWeight,
        fontWeightBold: dt.typography.default.body1.bold.fontWeight,
        display1: typographyResponsive(dt, "display01"),
        display2: typographyResponsive(dt, "display02"),
        display3: typographyResponsive(dt, "display03"),
        h1: typographyResponsive(dt, "H1"),
        h2: typographyResponsive(dt, "H2"),
        h3: typographyResponsive(dt, "H3"),
        h4: typographyResponsive(dt, "H4"),
        h5: typographyResponsive(dt, "H5"),
        h6: typographyResponsive(dt, "H6"),
        subtitle1: typographyResponsive(dt, "subtitle1.regular"),
        subtitle1Light: typographyResponsive(dt, "subtitle1.light"),
        subtitle1Medium: typographyResponsive(dt, "subtitle1.medium"),
        subtitle1Bold: typographyResponsive(dt, "subtitle1.bold"),
        subtitle2: typographyResponsive(dt, "subtitle2.regular"),
        subtitle2Light: typographyResponsive(dt, "subtitle2.light"),
        subtitle2Medium: typographyResponsive(dt, "subtitle2.medium"),
        subtitle2Bold: typographyResponsive(dt, "subtitle2.bold"),
        body1: typographyResponsive(dt, "body1.regular"),
        body1Light: typographyResponsive(dt, "body1.light"),
        body1Medium: typographyResponsive(dt, "body1.medium"),
        body1Bold: typographyResponsive(dt, "body1.bold"),
        body2: typographyResponsive(dt, "body2.regular"),
        body2Light: typographyResponsive(dt, "body2.light"),
        body2Medium: typographyResponsive(dt, "body2.medium"),
        body2Bold: typographyResponsive(dt, "body2.bold"),
        button: buttonTypography,
        buttonSmall: typographyResponsive(dt, "button.small"),
        buttonLarge: typographyResponsive(dt, "button.large"),
        caption: typographyResponsive(dt, "caption"),
        overline: typographyResponsive(dt, "overline"),
        playerLabelSmallSubtle: typography(dt.player.typography.label.small.default, dt.fontFamilies.body.fallback),
        playerLabelMediumSubtle: typography(dt.player.typography.label.medium.default, dt.fontFamilies.body.fallback),
        playerLabelLargeSubtle: typography(dt.player.typography.label.large.default, dt.fontFamilies.body.fallback),
        playerLabelSmall: typography(dt.player.typography.label.small.default, dt.fontFamilies.body.fallback),
        playerLabelMedium: typography(dt.player.typography.label.medium.default, dt.fontFamilies.body.fallback),
        playerLabelLarge: typography(dt.player.typography.label.large.default, dt.fontFamilies.body.fallback),
        playerLabelSmallEmphasis: typography(dt.player.typography.label.small.emphasis, dt.fontFamilies.body.fallback),
        playerLabelMediumEmphasis: typography(dt.player.typography.label.medium.emphasis, dt.fontFamilies.body.fallback),
        playerLabelLargeEmphasis: typography(dt.player.typography.label.large.emphasis, dt.fontFamilies.body.fallback),
        playerBodySmall: typography(dt.player.typography.body.small.default, dt.fontFamilies.body.fallback),
        playerBodyMedium: typography(dt.player.typography.body.medium.default, dt.fontFamilies.body.fallback),
        playerBodyLarge: typography(dt.player.typography.body.large.default, dt.fontFamilies.body.fallback),
        playerTitleSmall: typography(dt.player.typography.title.small.default, dt.fontFamilies.heading.fallback),
        playerTitleMedium: typography(dt.player.typography.title.medium.default, dt.fontFamilies.heading.fallback),
        playerTitleLarge: typography(dt.player.typography.title.large.default, dt.fontFamilies.heading.fallback),
        playerHeadlineSmall: typography(dt.player.typography.headline.small.default, dt.fontFamilies.heading.fallback),
        playerHeadlineMedium: typography(dt.player.typography.headline.medium.default, dt.fontFamilies.heading.fallback),
        playerHeadlineLarge: typography(dt.player.typography.headline.large.default, dt.fontFamilies.heading.fallback),
        playerTitle: typography(dt.typography.player.title, dt.fontFamilies.heading.fallback),
        playerSubHeader: typography(dt.typography.player.subHeader, dt.fontFamilies.heading.fallback),
        playerSubSubHeader: typography(dt.typography.default.H6, dt.fontFamilies.heading.fallback),
        playerQuestion: typography(dt.typography.player.question, dt.fontFamilies.heading.fallback),
        playerIntro: typography(dt.typography.player.intro, dt.fontFamilies.heading.fallback),
        playerInstruction: typography(dt.typography.player.instruction, dt.fontFamilies.heading.fallback),
        playerBody: typography(dt.typography.player.body, dt.fontFamilies.body.fallback),
    };
    return returnVar;
};
export const MuiTypographyTheme = (dt) => {
    return {
        defaultProps: {
            variantMapping: {
                display1: "h1",
                display2: "h2",
                display3: "h3",
                body1Light: "div",
                body1Medium: "div",
                body1Bold: "div",
                body2Light: "div",
                body2Medium: "div",
                body2Bold: "div",
                subtitle1Light: "h6",
                subtitle1Medium: "h6",
                subtitle1Bold: "h6",
                subtitle2Light: "h6",
                subtitle2Medium: "h6",
                subtitle2Bold: "h6",
                playerTitle: "h4",
                playerSubHeader: "h5",
                playerSubSubHeader: "h6",
                playerQuestion: "h4",
                playerIntro: "div",
                playerInstruction: "div",
                playerBody: "div",
                playerBodySmall: "div",
                playerBodyMedium: "div",
                playerBodyLarge: "div",
                playerTitleSmall: "h2",
                playerTitleMedium: "h2",
                playerTitleLarge: "h2",
                playerHeadlineSmall: "h1",
                playerHeadlineMedium: "h1",
                playerHeadlineLarge: "h1",
            },
        },
        styleOverrides: {
            root: {},
        },
        variants: [
            {
                props: { variant: "display1" },
                style: typographyResponsive(dt, "display01"),
            },
            {
                props: { variant: "display2" },
                style: typographyResponsive(dt, "display02"),
            },
            {
                props: { variant: "display3" },
                style: typographyResponsive(dt, "display03"),
            },
            {
                props: { variant: "body1Light" },
                style: typographyResponsive(dt, "body1.light"),
            },
            {
                props: { variant: "body1Medium" },
                style: typographyResponsive(dt, "body1.medium"),
            },
            {
                props: { variant: "body1Bold" },
                style: typographyResponsive(dt, "body1.bold"),
            },
            {
                props: { variant: "body2Light" },
                style: typographyResponsive(dt, "body2.light"),
            },
            {
                props: { variant: "body2Medium" },
                style: typographyResponsive(dt, "body2.medium"),
            },
            {
                props: { variant: "body2Bold" },
                style: typographyResponsive(dt, "body2.bold"),
            },
            {
                props: { variant: "buttonSmall" },
                style: typographyResponsive(dt, "button.small"),
            },
            {
                props: { variant: "buttonLarge" },
                style: typographyResponsive(dt, "button.large"),
            },
            {
                props: { variant: "subtitle1Light" },
                style: typographyResponsive(dt, "subtitle1.light"),
            },
            {
                props: { variant: "subtitle1Medium" },
                style: typographyResponsive(dt, "subtitle1.medium"),
            },
            {
                props: { variant: "subtitle1Bold" },
                style: typographyResponsive(dt, "subtitle1.bold"),
            },
            {
                props: { variant: "subtitle2Light" },
                style: typographyResponsive(dt, "subtitle2.light"),
            },
            {
                props: { variant: "subtitle2Medium" },
                style: typographyResponsive(dt, "subtitle2.medium"),
            },
            {
                props: { variant: "subtitle2Bold" },
                style: typographyResponsive(dt, "subtitle2.bold"),
            },
            {
                props: { variant: "playerTitle" },
                style: typography(dt.typography.player.title, dt.fontFamilies.heading.fallback),
            },
            {
                props: { variant: "playerSubHeader" },
                style: typography(dt.typography.player.subHeader, dt.fontFamilies.heading.fallback),
            },
            {
                props: { variant: "playerSubSubHeader" },
                style: typography(dt.typography.default.H6, dt.fontFamilies.heading.fallback),
            },
            {
                props: { variant: "playerQuestion" },
                style: typography(dt.typography.player.question, dt.fontFamilies.body.fallback),
            },
            {
                props: { variant: "playerIntro" },
                style: typography(dt.typography.player.intro, dt.fontFamilies.body.fallback),
            },
            {
                props: { variant: "playerInstruction" },
                style: typography(dt.typography.player.instruction, dt.fontFamilies.body.fallback),
            },
            {
                props: { variant: "playerBody" },
                style: typography(dt.typography.player.body, dt.fontFamilies.body.fallback),
            },
        ],
    };
};
